<template>
  <!-- 单菜单 -->
  <router-link v-if="isSingle" :to="resolvePath(singleChildRoute.path)">
    <el-menu-item class="hn-menu-item" :index="resolvePath(singleChildRoute.path)" @click="handleClick(singleChildRoute)">
      <div class="hn-menu-item-prefix" v-if="iconName">
        <SvgIcon :icon="iconName" />
      </div>
      <template #title>
        <span class="hn-menu-item-text line-clamp1">
          {{ singleChildRoute.meta?.title }}
          <strong v-if="singleChildRoute.wxGzhUnRead > 0">({{ singleChildRoute.wxGzhUnRead }})</strong>
        </span>
      </template>
    </el-menu-item>
  </router-link>

  <!-- 多菜单 -->
  <el-submenu class="hn-submenu" v-else :index="item.path">
    <template #title>
      <div class="hn-submenu-title-prefix" v-if="iconName">
        <SvgIcon :icon="iconName" />
      </div>
      <span>{{ item.meta?.title }}</span>
    </template>
    <SidebarItem
      v-for="child in filteredChildren"
      :key="child.path"
      :item="child"
      :base-path="resolvePath(child.path)"
    ></SidebarItem>
  </el-submenu>
</template>

<script>
import { resolve } from 'path-browserify';
import { isExternal } from '@/utils/validate';

export default {
  name: "SidebarItem",
  components: {
  },
  props: {
    item: Object,
    basePath: String,
  },
  data() {
    return {};
  },
  computed: {
    // 计算过滤后的子节点，排除隐藏项
    filteredChildren(){
      return (this.item.children || []).filter((child) => !child.meta?.hidden);
    },
    // 是否单菜单
    isSingle(){
      return this.filteredChildren.length < 1 || (this.filteredChildren.length === 1 && !this.item.meta?.alwaysShow)
    },
    // 计算单一子节点 (要渲染的路由)
    singleChildRoute(){
      return this.filteredChildren.length === 1 
        ? this.filteredChildren[0] 
        : { ...this.item, path: '' }
        // 此处将自己的path置为''，防止重复拼接
    },
    // 要渲染的图标
    iconName(){
      if (this.isSingle) return this.singleChildRoute.meta?.icon;
      return this.item.meta?.icon || this.singleChildRoute.meta?.icon;
    }
  },
  mounted() {},
  methods: {
    //解析父路径 + 子路径
    // '/a' + b -> '/a/b'
    // '/a' + '/c/b' ->'/c/b'
    resolvePath(childPath){
      if (isExternal(childPath)) return childPath;
      return resolve(this.basePath, childPath);
    },
    handleClick(view){
      //删除点击导航的路由缓存（点击侧边栏菜单时，不取缓存路由）
      this.$store.commit('tagsView/deleteCacheRouteName', view);
    }
  },
};
</script>

<style lang="scss" scoped>
@mixin menuItem(){
  display: flex;
  align-items: center;
  margin: 10px 15px 0;
  padding: 8px 10px;
  height: auto;
  line-height: 30px;
  font-size: 16px;
  background: transparent !important;
  border-radius: 3px;
  transition: all 0.15s ease-in;
  &:hover{background: transparent;}
}

.hn{
  &-submenu{
    ::v-deep{
      .el-submenu__title{
        @include menuItem();
      }
      .el-submenu__icon-arrow{
        color: #fff;
      }
      &.is-active{
        .el-submenu__title{
          background: rgba(200, 200, 200, 0.2) !important;
        }
      }
    }
  }
  &-menu-item{
    @include menuItem();
    width: auto;
    font-size: 14px;
    white-space: nowrap;
    &:hover{
      font-weight: 700;
      font-size: 16px;
    }
    &.is-active{
      color: #fff;
      background-color: #4EB0A6 !important;
    }
    &-text{
      strong{
        color: red;
      }
    }
  }
  &-menu-item-prefix,
  &-submenu-title-prefix{
    margin-right: 10px;
    display: inline-block;
  }
}
</style>
